import { SectionTitle } from "components/sectionTitle";
import FeaturesStyleWrapper from "./Features.style";
import thumb1 from "assets/images/icons/Key_icon1.png";
import thumb2 from "assets/images/icons/Key_icon2.png";
import thumb3 from "assets/images/icons/Key_icon3.png";
import thumb4 from "assets/images/icons/Key_icon4.png";
import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation();
  const data = [
    {
      icon: thumb1,
      title: t("features.title1"),
      text: t("features.description1"),
    },
    {
      icon: thumb2,
      title: t("features.title2"),
      text: t("features.description2"),
    },
    {
      icon: thumb3,
      title: t("features.title3"),
      text: t("features.description3"),
    },
    {
      icon: thumb4,
      title: t("features.title4"),
      text: t("features.description4"),
    },
  ];
  return (
    <FeaturesStyleWrapper id="buytokens">
      <div className="key_points_section main-project-area">
        <div className="container">
          <div className="sec-inner align-items-center">
            <SectionTitle
              subtitle={t("features.subtitle")}
              title={t("features.title")}
            />
            <div className="key_points_conttent">
              <div className="row items-row">
                {data?.map((item, i) => (
                  <div key={i} className="col-md-6 col-lg-3">
                    <div className="key_points_item">
                      <div className="key_points_item_img">
                        <img src={item.icon} alt="icon" className="img-fluid" />
                      </div>
                      <div className="key_points_item_text">
                        <h4>{item.title}</h4>
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </FeaturesStyleWrapper>
  );
};

export default Features;
